
<app-preloader 
*ngIf="load"
></app-preloader>
<section id="new-thrift" *ngIf="!load">

    
    <!-- <div class="container">
        
        <div class="thrift-form">
            <h3>SIGNUP TO Thrively <small>Fill in all required details</small></h3>
            <form [formGroup]="Register" (ngSubmit)="signUp()" >
              <section id="first" *ngIf="page1">

                <fieldset>
                  <legend>First Name</legend>
                  <input type="text"
                  id="firstname"
                  formControlName="firstname"
                  name="firstname"
                  required>
                </fieldset>
  
                <fieldset>
                  <legend>Last Name</legend>
                  <input type="text"
                  id="lastname"
                  formControlName="lastname"
                  name="lastname"
                  required>
                </fieldset>
  
                <fieldset>
                  <legend>Date Of Birth</legend>
                  <input type="date"
                  id="date_of_birth"
                  formControlName="date_of_birth"
                  name="date_of_birth"
                  required>
                </fieldset>
                
                <button (click)="navigatenewUser()" style="background: transparent; border: 2px solid #4548EA; color: #4548EA; ">Already a User ?</button>
              <button style="margin-left: 3vh;" (click)="nextPage(2)" >Next</button> 
               
              </section>
             
              <section id="second" *ngIf="page2">

                <fieldset>
                  <legend>Email</legend>
                  <input type="email"
                  id="email"
                  formControlName="email"
                  name="email"
                  required>
                </fieldset>
  
                <fieldset>
                  <legend>Phone Number</legend>
                  <input type="text"
                  id="phonenumber"
                  formControlName="phonenumber"
                  name="phonenumber"
                  required>
                </fieldset>
  
                <fieldset>
                  <legend>Home Address</legend>
                  <input type="text"
                  id="address"
                  formControlName="address"
                  name="address"
                  required>
                </fieldset>
                <button (click)="nextPage(1)" style="background: transparent; border: 2px solid #4548EA; color: #4548EA; ">Previous</button>
                <button style="margin-left: 3vh;" (click)="nextPage(3)" >Next</button> 
  
              </section>

              <section id="last" *ngIf="lastPage">
                 <fieldset>
                <legend>Country</legend>
                <select name="country"
                 id="country"
                 formControlName="country"
                 required>
                  <option  *ngFor="let countryList of country; let i = index " value={{countryList.country}}> {{countryList.country}}</option>
                </select>
               
              </fieldset>

              <fieldset>
                <legend>Choose a PIN</legend>
                <input type="password"
                id="password"
                formControlName="password"
                name="password"
                required>
              </fieldset>
              <button (click)="nextPage(2)" style="background: transparent; border: 2px solid #4548EA; color: #4548EA; ">Previous</button>
              <button style="margin-left: 3vh;" type="submit" [disabled]="Register.invalid" >Signup</button> -->
              <!-- <button (click)="navigatenewUser()" style="background: transparent; border: 2px solid #4548EA; color: #4548EA; ">Already a User ?</button> -->
<!-- 
              </section>
         
            
            </form>
        </div>
    </div> -->


    <div class="login-page">
      <div class="container d-flex align-items-center">
        <div class="form-holder has-shadow">
          <div class="row">
            <!-- Logo & Information Panel-->
            <div class="col-lg-6">
              <div class="info d-flex align-items-center">
                <div class="content">
                  <div class="logo">
                    <h1>THRIVELY</h1>
                  </div>
                  <p style="text-transform: capitalize;">adashi... esusu... ajo... <br> contribute, be empowered & thrive </p>
                </div>
              </div>
            </div>
            <!-- Form Panel    -->
            <div class="col-lg-6 bg-white">
              <div class="form d-flex align-items-center">
                <div class="content">
                  <!-- Form Section -->
                  <form [formGroup]="Register" (ngSubmit)="signUp()" class="form-validate">

                    <section id="first" *ngIf="page1">
                    <div class="form-group">
                      <span class="mt-2">First Name</span>
                      <input id="login-username" type="text"
                      id="firstname"
                      formControlName="firstname"
                      
                      autocomplete="off"
                      name="firstname" 
                      required data-msg="Please enter your first name" class="input-material">
                      <!-- <label for="login-username" class="label-material">First Name</label> -->
                      
                    </div>
                    <div class="form-group">
                      <span class="mt-2">Last Name</span>
                      <input id="login-lastname"  type="text"
                      id="login-username"
                      formControlName="lastname"
                      name="password"
                       required data-msg="Please enter your lastname" class="input-material">

                      <!-- <label for="login-lastname" class="label-material">Last Name</label> -->
                     
                    </div>

                    <div class="form-group">
                      <span class="mt-2">Date Of Birth</span>
                      <input id="date" type="date"
                      ng
                      formControlName="date_of_birth"
                      max="2006-12-31"
                      min="1930-01-01"
                      aria-controls="off"
                      autocomplete="off"
                      required data-msg="Please enter your date of birth" class="input-material">
                      <!-- <label for="login-username" class="label-material">Date Of Birth</label> -->
                      
                    </div>
                    <button id="login"  (click)="nextPage(2)" class="btn btn-primary ml-2 col-lg-7">Next</button>
                    </section>

                    <section id="second" *ngIf="page2">

                      <div class="form-group">
                        <span class="mt-2">Email Address</span>
                        <input id="login-lastname"  type="email"
                        
                        formControlName="email"
                        name="email"
                         required data-msg="Enter a valid email" class="input-material">
                        
                         
                        <!-- <label for="login-password" class="label-material">Last Name</label> -->
                      </div>

                      <div class="form-group">
                        <span class="mt-2">Phone Number</span>
                        <input id="login-phone"  type="text"
                        
                        formControlName="phonenumber"
                        name="login-username"
                         required data-msg="Please enter your phonenumber" class="input-material" placeholder="Phone Number"/>
  
                        <!-- <label for="login-username" class="label-material">Phone Number</label> -->
                        
                      </div>
  
                      <div class="form-group">
                        <span class="mt-2">Home Address</span>
                        <input id="login-address"type="text"
                        id="address"
                        formControlName="address"
                        name="address"
                         required data-msg="Please enter your home address" class="input-material" placeholder="Home Address">
                         
                        <!-- <label for="login-password" class="label-material">Home Address</label> -->
                      </div>

                      <button id="login"  (click)="nextPage(1)" style="background-color: transparent;" class="btn btn-primary col-lg-4">Previous</button> <button id="login"  (click)="nextPage(3)" class="btn btn-primary ml-2 col-lg-7">Next</button>
                      </section>


                      <section id="third" *ngIf="lastPage">
                        <div class="form-group">
                          
                          <!-- <input id="login-username"  type="text"
                          id="login-username"
                          formControlName="country"
                          name="country"
                           required data-msg="Enter a valid email" placeholder="Country" class="input-material">
                           -->
                           <span class="mt-2">Select Your Country</span>
                           <select name="country"
                 id="country"
                 formControlName="country"
                 style="background: transparent; border: none; border-bottom: 2px solid #fff; color: #fff;"
                 required>
                  <option style="  background: rgba(236, 217, 219, 0.95) ; color: black; font-family: monospace;"  *ngFor="let countryList of country; let i = index " value={{countryList.country}}> {{countryList.country}}</option>
                </select>
                           
                          <!-- <label for="login-password" class="label-material">Last Name</label> -->
                        </div>
  
                        <div class="form-group">
                          <span class="mt-2">Choose A Pin</span>
                          <input id="login-username"  type="text"
                          
                          formControlName="password"
                          name="login-username"
                           required data-msg="Choose a pin" class="input-material" placeholder="Choose a Pin"/>
    
                          <!-- <label for="login-username" class="label-material">Phone Number</label> -->
                          
                        </div>
    
                        
                        <button id="login"  (click)="nextPage(2)" style="background-color: transparent;" class="btn btn-primary col-lg-4">Previous</button> <button id="login" [disabled]="Register.invalid" type="submit" class="btn btn-primary ml-2 col-lg-7">Register</button>
                        </section>
                     
                    
                    <!-- <button id="login" class="btn btn-primary col-lg-4">Register</button> <button id="login" class="btn btn-primary ml-2 col-lg-7">Register</button> -->
                    <!-- This should be submit button but I replaced it with <a> for demo purposes-->
                  </form><br><small>Already have an account? </small><a style="cursor: pointer ;" (click)="navigatenewUser()"class="signup">Signin</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      </div>
</section>